<!--
  @file Componente DateRangePicker.vue
  @description Componente para filtrar un rango de fechas

  @author Adrian Zayas <adrianzayas@unindetec.edu.mx>
  @date 26-03-2025
  @version 1.0.1
  @updateDescription: Se agregó validación para retornar null cuando el dateRange se limpie
-->
<template>
    <div>
        <label v-if="!ocultarLabel" for="alertas-date-picker" class="lbl">Obtener alertas por rango de fechas</label>
        <div class="date-range-picker">
            <b-input-group class="mb-2 align-items-center">
                <b-input-group-prepend is-text>
                    <b-icon icon="calendar4-range" class="icon-calendar"></b-icon>
                </b-input-group-prepend>
                <flat-pickr id="alertas-date-picker" v-model="dateRange" :config="configDateRange" class="flatpickr-input"
                    :placeholder="$t('Gral.seleccionar')" name="date" />
            </b-input-group>
        </div>
        <b-button v-if="!ocultarBoton" class="w-100 mb-2" :disabled="!dateRange" @click="dateRange = null"
            variant="info" style="color:white">
            {{ $t("Gral.limpiarBusqueda") }}
        </b-button>
    </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { Spanish } from "flatpickr/dist/l10n/es.js";

import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css";
export default {
    components: {
        flatPickr,
    },
    props: {
        ocultarLabel: {
            type: Boolean,
            default: false,
        },
        ocultarBoton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dateRange: null,
            configDateRange: {
                wrap: true,
                altFormat: "M j, Y",
                altInput: true,
                dateFormat: "Y-m-d",
                minDate: new Date().fp_incr(-30),
                maxDate: new Date(),
                mode: "range",
                locale: Spanish,
            },
            date: { start: null, end: null, }
        }
    },
    emits: ["inputDate"],
    watch: {
        dateRange(newDate) {
            if (newDate) {
                this.convertDateRange();
                this.$emit('inputDate', this.date);
            } else {
                this.date = { start: null, end: null };
                this.$emit('inputDate', null);
            }
        }
    },
    methods: {
        convertDateRange() {
            if (!this.dateRange) {
                this.date = { start: null, end: null };
                return;
            }

            const arrayDate = this.dateRange.split(" ");
            this.date.start = arrayDate[0];

            if (arrayDate.length > 2) {
                this.date.end = arrayDate[2];
            } else {
                this.date.end = this.date.start;
            }
        },
    },//FIN Methods
}
</script>

<style>
.lbl {
    color: rgb(41, 41, 41);
}

.icon-calendar {
    font-size: 1.2rem;
    display: flex;
    align-items: center;
}

.flatpickr-input {
    height: 34px;
    width: 100%;
    border-radius: 5px;
    padding: 8px 10px;
}
</style>